import React from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

import App from "apps/notifications_footer/components/App";

import isRouteMatch from "shared/util/isRouteMatch";
import { ROUTES, ROUTE_LIST } from "routers/shared/util/consts";

const NO_NOTIFICATION_ROUTES = [
	...ROUTES.Offboarding,
	...ROUTES.Onboarding,
	...ROUTES.PhoneWall,
	...ROUTES.StandaloneConversation,
];

const NotificationsFooter = ({ userid }) => {
	const location = useLocation();
	const is404 = !isRouteMatch(location, ROUTE_LIST);
	const showNotificationsFooter = !is404 && !isRouteMatch(location, NO_NOTIFICATION_ROUTES);

	// Exit if no show.
	if (!showNotificationsFooter) {
		return null;
	}

	return (
		<App userid={userid} />
	);
};

NotificationsFooter.propTypes = {
	userid: PropTypes.string.isRequired,
};

export default NotificationsFooter;



// WEBPACK FOOTER //
// ./src/apps/notifications_footer/index.js